import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { cn } from '~/lib/utils';
import type { MenuChild } from '~/lib/menu';
import { useActiveMenuPath } from '~/hooks/use-active-menu-path';
import { AiPendingCountBadge } from './ai-pending-count-badge';
import { PendingReviewsCountBadge } from './pending-reviews-count-badge';

/** A child (leaf) row inside an expanded parent. 24px, indented, text-only (+ optional live badge). */
export function SidebarSubItem({ child }: { child: MenuChild }) {
	const { t } = useTranslation();
	const active = child.path === useActiveMenuPath();
	return (
		<Link
			to={child.path}
			className={cn(
				'flex h-6 items-center py-1 pr-2.5 text-[11.5px] transition-colors',
				active
					? 'border-l-[3px] border-l-brand bg-brand-subtle pl-[33px] font-medium text-brand-subtle-fg'
					: 'pl-9 font-normal text-foreground-muted hover:bg-muted'
			)}>
			<span className="truncate">{t(child.labelKey)}</span>
			{child.badge === 'aiPendingCount' && <AiPendingCountBadge />}
			{child.badge === 'pendingReviewsCount' && <PendingReviewsCountBadge />}
		</Link>
	);
}
